import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { METHODS, SERVICES } from '../../api/constants';
import { commonMoodlePayload } from '../../config';
import { makeRequest } from '../../api/api';
import { MOODLE_BACKEND_ROUTES } from '../../config/apiRoutes';
import CryptoJS from 'crypto-js';

export const getCalendarEvents = createAsyncThunk(
  'dashboard/getCalendarEvents',
  async (param, thunkApi) => {
    const data = {
      ...param,
      ...commonMoodlePayload,
      wsfunction: MOODLE_BACKEND_ROUTES.GET_CALENDAR_EVENTS,
      wstoken: thunkApi.getState().auth.token
    };
    try {
      const response = await makeRequest(
        SERVICES.MOODLE_SERVICE,
        '',
        METHODS.GET,
        { ...data, details: 1 }
      );
      return response.data;
    } catch (e) {
      thunkApi.rejectWithValue(e);
    }
  }
);

export const getCalenderMark = createAsyncThunk(
  'dashboard/getCalenderMark',
  async (param, thunkApi) => {
    try {
      const response = await makeRequest(
        SERVICES.MOODLE_SERVICE,
        '',
        METHODS.GET,
        {
          ...param,
          ...commonMoodlePayload,
          wsfunction: MOODLE_BACKEND_ROUTES.GET_CALENDAR_EVENTS,
          wstoken: thunkApi.getState().auth.token
        }
      );
      return response.data;
    } catch (e) {
      thunkApi.rejectWithValue(e);
    }
  }
);

export const getLiveCLass = createAsyncThunk(
  'dashboard/getLiveCLass',
  async (param, thunkApi) => {
    try {
      const response = await makeRequest(
        SERVICES.MOODLE_SERVICE,
        '',
        METHODS.GET,
        {
          ...param,
          ...commonMoodlePayload,
          wsfunction: MOODLE_BACKEND_ROUTES.GET_LIVE_CLASS,
          wstoken: thunkApi.getState().auth.token
        }
      );
      return response.data;
    } catch (e) {
      thunkApi.rejectWithValue(e);
    }
  }
);

export const getReminders = createAsyncThunk(
  'dashboard/getReminders',
  async (param, thunkApi) => {
    try {
      const response = await makeRequest(
        SERVICES.MOODLE_SERVICE,
        '',
        METHODS.GET,
        {
          ...param,
          ...commonMoodlePayload,
          wsfunction: MOODLE_BACKEND_ROUTES.GET_REMINDER_CLASS,
          wstoken: thunkApi.getState().auth.token
        }
      );
      return response.data;
    } catch (e) {
      thunkApi.rejectWithValue(e);
    }
  }
);

export const getClasses = createAsyncThunk(
  'dashboard/getClasses',
  async (param, thunkApi) => {
    try {
      const response = await makeRequest(
        SERVICES.MOODLE_SERVICE,
        '',
        METHODS.GET,
        {
          ...param?.data,
          ...commonMoodlePayload,
          wsfunction: MOODLE_BACKEND_ROUTES.GET_CLASSES,
          wstoken: thunkApi.getState().auth.token
        }
      );
      if (
        param.intial &&
        !response.data?.sessions?.length &&
        param.data?.type == 'future'
      ) {
        thunkApi.dispatch(
          getClasses({
            data: { ...param?.data, type: 'past' }
          })
        );
      }
      return response.data;
    } catch (e) {
      thunkApi.rejectWithValue(e);
    }
  }
);
export const getAssignment = createAsyncThunk(
  'dashboard/getAssignment',
  async (param, thunkApi) => {
    try {
      const response = await makeRequest(
        SERVICES.MOODLE_SERVICE,
        '',
        METHODS.GET,
        {
          ...param,
          ...commonMoodlePayload,
          wsfunction: MOODLE_BACKEND_ROUTES.GET_ASSIGNMENT,
          wstoken: thunkApi.getState().auth.token
        }
      );
      return response.data;
    } catch (e) {
      thunkApi.rejectWithValue(e);
    }
  }
);
export const getQuizzes = createAsyncThunk(
  'dashboard/getQuizzes',
  async (param, thunkApi) => {
    try {
      const response = await makeRequest(
        SERVICES.MOODLE_SERVICE,
        '',
        METHODS.GET,
        {
          ...param,
          ...commonMoodlePayload,
          wsfunction: MOODLE_BACKEND_ROUTES.GET_QUIZZES,
          wstoken: thunkApi.getState().auth.token
        }
      );
      return response.data;
    } catch (e) {
      thunkApi.rejectWithValue(e);
    }
  }
);

export const getRecentlyViewedCourse = createAsyncThunk(
  'dashboard/getRecentlyViewedCourse',
  async (param, thunkApi) => {
    try {
      const response = await makeRequest(
        SERVICES.MOODLE_SERVICE,
        '',
        METHODS.GET,
        {
          ...param,
          ...commonMoodlePayload,
          wsfunction: MOODLE_BACKEND_ROUTES.GET_RECENT_PROGRAM_COURSES,
          wstoken: thunkApi.getState().auth.token
        }
      );
      return response.data;
    } catch (e) {
      thunkApi.rejectWithValue(e);
    }
  }
);

export const getWeeklyPlan = createAsyncThunk(
  'dashboard/getWeeklyPlan',
  async (param, thunkApi) => {
    try {
      const hash = CryptoJS.HmacSHA256(
        JSON.stringify(param),
        '2d1e1v2e4s3h8zkkhehkod2d02fhjewjbd2whj4'
      ).toString(CryptoJS.enc.Hex);

      const response = await makeRequest(
        SERVICES.SPRINGBOOT_TO_NODE_APIS,
        '/dashboard/weekly-milestone',
        METHODS.POST,
        {},
        {
          ...param
        },
        [
          { key: 'access-key', value: 'sxb0zhsqm8yjpttc79iqlizxyd3e1a2' },
          { key: 'signature', value: hash }
        ]
      );
      return response.data;
    } catch (e) {
      thunkApi.rejectWithValue(e);
    }
  }
);

export const getContinueLearningData = createAsyncThunk(
  'dashboard/getContinueLearningData',
  async (param, thunkApi) => {
    try {
      const hash = CryptoJS.HmacSHA256(
        JSON.stringify(param),
        '2d1e1v2e4s3h8zkkhehkod2d02fhjewjbd2whj4'
      ).toString(CryptoJS.enc.Hex);

      const response = await makeRequest(
        SERVICES.SPRINGBOOT_TO_NODE_APIS,
        '/dashboard/weekly-milestone',
        METHODS.POST,
        {},
        {
          ...param
        },
        [
          { key: 'access-key', value: 'sxb0zhsqm8yjpttc79iqlizxyd3e1a2' },
          { key: 'signature', value: hash }
        ]
      );
      return response.data;
    } catch (e) {
      thunkApi.rejectWithValue(e);
    }
  }
);

export const getCurrentEpoch = createAsyncThunk(
  'dashboard/getCurrentEpoch',
  async (param, thunkApi) => {
    try {
      const hash = CryptoJS.HmacSHA256(
        JSON.stringify(param),
        '2d1e1v2e4s3h8zkkhehkod2d02fhjewjbd2whj4'
      ).toString(CryptoJS.enc.Hex);

      const response = await makeRequest(
        SERVICES.SPRINGBOOT_TO_NODE_APIS,
        '/dashboard/get-current-epoch',
        METHODS.GET,
        {},
        {},
        [
          { key: 'access-key', value: 'sxb0zhsqm8yjpttc79iqlizxyd3e1a2' },
          { key: 'signature', value: hash }
        ]
      );
      return response.data;
    } catch (e) {
      thunkApi.rejectWithValue(e);
    }
  }
);

export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: {
    loading: true,
    calendarLoading: true,
    calendarData: [],
    calendarMarksLoading: true,
    calendarMarksData: {},
    liveClassLoading: true,
    liveClassData: [],
    remindersData: [],
    reminderLoading: true,
    classLoading: true,
    classesData: [],
    quizLoading: true,
    quizData: [],
    assignmentLoading: true,
    assignmentData: [],
    recentCourseViewedLoading: true,
    recentCourseData: [],
    isWeeklyPlanLoading: false,
    weeklyPlanData: [],
    isContinueLearningLoading: false,
    ContinueLearningData: [],
    currentEpoch: null,
    theme: localStorage?.getItem('vlearn-theme') || ''
  },
  reducers: {
    resetState: (state, action) => {
      state.calendarLoading = true;
      state.calendarData = [];
      state.calendarMarksLoading = true;
      state.calendarMarksData = {};
    },
    updateTheme: (state, action) => {
      state.theme = action?.payload || '';
      localStorage.setItem('vlearn-theme', action?.payload || '');
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getCalendarEvents.pending, (state) => {
      state.calendarLoading = true;
    });
    builder.addCase(getCalendarEvents.fulfilled, (state, action) => {
      state.calendarLoading = false;
      state.calendarData = action?.payload?.events || [];
    });
    builder.addCase(getCalendarEvents.rejected, (state) => {
      state.calendarLoading = false;
      state.calendarData = [];
    });
    builder.addCase(getReminders.pending, (state) => {
      state.reminderLoading = true;
    });
    builder.addCase(getReminders.fulfilled, (state, action) => {
      state.reminderLoading = false;
      state.remindersData =
        action?.payload?.reminders?.sort((a, b) => b.date - a.date) || [];
      // arr.sort((a, b) => a.date - b.date) asc
    });
    builder.addCase(getReminders.rejected, (state) => {
      state.reminderLoading = false;
      state.remindersData = [];
    });
    builder.addCase(getLiveCLass.pending, (state) => {
      state.liveClassLoading = true;
    });
    builder.addCase(getLiveCLass.fulfilled, (state, action) => {
      state.liveClassLoading = false;
      state.liveClassData = action?.payload || [];
    });
    builder.addCase(getLiveCLass.rejected, (state) => {
      state.liveClassLoading = false;
      state.liveClassData = [];
    });
    builder.addCase(getClasses.pending, (state) => {
      state.classLoading = true;
    });
    builder.addCase(getClasses.fulfilled, (state, action) => {
      const param = action?.meta?.arg;
      if (
        !(
          param.intial &&
          !action?.payload?.sessions?.length &&
          param.data?.type == 'future'
        )
      ) {
        state.classLoading = false;
      }
      state.classesData = action?.payload?.sessions || [];
    });
    builder.addCase(getClasses.rejected, (state) => {
      state.classLoading = false;
      state.classesData = [];
    });
    builder.addCase(getQuizzes.pending, (state) => {
      state.quizLoading = true;
    });
    builder.addCase(getQuizzes.fulfilled, (state, action) => {
      state.quizLoading = false;
      state.quizData = action?.payload || [];
    });
    builder.addCase(getQuizzes.rejected, (state) => {
      state.quizLoading = false;
      state.quizData = [];
    });
    builder.addCase(getAssignment.pending, (state) => {
      state.assignmentLoading = true;
    });
    builder.addCase(getAssignment.fulfilled, (state, action) => {
      state.assignmentLoading = false;
      state.assignmentData = action?.payload || [];
    });
    builder.addCase(getAssignment.rejected, (state) => {
      state.assignmentLoading = false;
      state.assignmentData = [];
    });
    builder.addCase(getRecentlyViewedCourse.pending, (state) => {
      state.recentCourseViewedLoading = true;
    });
    builder.addCase(getRecentlyViewedCourse.fulfilled, (state, action) => {
      state.recentCourseViewedLoading = false;
      state.recentCourseData = action?.payload?.coursedata || [];
    });
    builder.addCase(getRecentlyViewedCourse.rejected, (state) => {
      state.recentCourseViewedLoading = false;
      state.recentCourseData = [];
    });
    builder.addCase(getCalenderMark.pending, (state) => {
      state.calendarMarksLoading = true;
    });
    builder.addCase(getCalenderMark.fulfilled, (state, action) => {
      state.calendarMarksLoading = false;
      if (action.payload.events?.length) {
        state.calendarMarksData = action?.payload?.events.reduce(
          (acc, event) => {
            const date = new Date(event.timestart * 1000);

            const dateKey = new Date(date.setHours(0, 0, 0, 0)).getTime();
            acc[dateKey] = event;
            return acc;
          },
          {}
        );
      }
    });
    builder.addCase(getCalenderMark.rejected, (state) => {
      state.calendarMarksLoading = false;
      state.calendarMarksData = {};
    });
    builder.addCase(getWeeklyPlan.pending, (state) => {
      state.isWeeklyPlanLoading = true;
    });
    builder.addCase(getWeeklyPlan.fulfilled, (state, action) => {
      state.isWeeklyPlanLoading = false;
      state.weeklyPlanData = action?.payload?.data || [];
    });
    builder.addCase(getWeeklyPlan.rejected, (state) => {
      state.isWeeklyPlanLoading = false;
      state.weeklyPlanData = [];
    });
    builder.addCase(getContinueLearningData.pending, (state) => {
      state.isContinueLearningLoading = true;
    });
    builder.addCase(getContinueLearningData.fulfilled, (state, action) => {
      state.isContinueLearningLoading = false;
      state.ContinueLearningData = action?.payload?.data || [];
    });
    builder.addCase(getContinueLearningData.rejected, (state) => {
      state.isContinueLearningLoading = false;
      state.ContinueLearningData = [];
    });
    builder.addCase(getCurrentEpoch.fulfilled, (state, action) => {
      state.currentEpoch = Math?.round(action?.payload?.epoch) || null;
    });
  }
});

export const { handleBookmark, resetState, updateTheme } =
  dashboardSlice.actions;

export default dashboardSlice.reducer;
